import { REPORT_EVENT_LABEL } from './constants';

const DAY_LABEL = new Intl.DateTimeFormat('en-IN', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
const AXIS_LABEL = new Intl.DateTimeFormat('en-IN', { day: 'numeric', month: 'short', timeZone: 'UTC' });
const MONTH_LABEL = new Intl.DateTimeFormat('en-IN', { month: 'long', year: 'numeric', timeZone: 'UTC' });
const MONTH_AXIS_LABEL = new Intl.DateTimeFormat('en-IN', { month: 'short', timeZone: 'UTC' });

/**
 * `2026-10-06` → "Tue, 6 Oct" for a tooltip and "6 Oct" for an axis.
 * Read as UTC because the API's days are calendar dates at UTC midnight.
 */
export function dayLabels(day: string): { label: string; axisLabel: string } {
  const date = new Date(`${day}T00:00:00Z`);
  return { label: DAY_LABEL.format(date), axisLabel: AXIS_LABEL.format(date) };
}

/** `2026-10` → "October 2026" for a tooltip and "Oct" for an axis. */
export function monthLabels(month: string): { label: string; axisLabel: string } {
  const date = new Date(`${month}-01T00:00:00Z`);
  return { label: MONTH_LABEL.format(date), axisLabel: MONTH_AXIS_LABEL.format(date) };
}

/**
 * Change against the previous period, as a whole percentage. Null when there is
 * nothing to compare with — a first period is "new", not "+∞%".
 */
export function percentChange(current: number, previous: number): number | null {
  if (previous === 0) return null;
  return Math.round(((current - previous) / previous) * 100);
}

/** `SUBSCRIPTION_PAYMENT_RECORDED` → its label, or "Subscription payment recorded" from the code. */
export function eventLabel(action: string): string {
  const known = REPORT_EVENT_LABEL[action];
  if (known) return known;
  const words = action.toLowerCase().replace(/_/g, ' ');
  return words.charAt(0).toUpperCase() + words.slice(1);
}
